import fb from '@/firebaseConfig';

const state = {
  user: {
    loggedIn: false,
    details: { displayName: '', email: '', uid: '', dbx_token: '' },
  },
};

const getters = {
  user(state) {
    return state.user;
  },
};

const mutations = {
  SET_LOGGED_IN(state, value) {
    state.user.loggedIn = value;
  },
  SET_USER(state, data) {
    state.user.details = data;
  },
};
const actions = {
  fetchUserProfile({ commit }, fbUser) {
    if (fbUser) {
      fb.db
        .collection('users')
        .doc(fbUser.uid)
        .get()
        .then((res) => {
          commit('SET_USER', {
            displayName: res.data().name,
            email: fbUser.email,
            uid: fbUser.uid,
            dbx_token: res.data().dbx_token,
          });
          commit('SET_LOGGED_IN', true);
        })
        .catch((err) => alert('Error in fetchUserProfile: ' + err));
    } else {
      commit('SET_LOGGED_IN', false);
      commit('SET_USER', null);
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
};
